export const colors = {
  success: {
    block: 'bg-success-25 !border border-success-150',
    text: 'text-success-500',
    progressBar: {
      outer: 'bg-success-100',
      inner: 'bg-success-500',
    },
  },
  warning: {
    block: '!bg-warning-50 !border !border-warning-200',
    text: 'text-warning-500',
    progressBar: {
      outer: 'bg-warning-100',
      inner: 'bg-warning-500',
    },
  },
  error: {
    block: 'bg-error-25 !border !border-error-300',
    text: 'text-error-500',
    progressBar: {
      outer: 'bg-error-100',
      inner: 'bg-error-500',
    },
  },
  blue: {
    block: 'bg-[#ECF4FD] !border !border-[#338AF3]',
    text: 'text-[#338AF3]',
    progressBar: {
      outer: 'bg-[#D1E4FA]',
      inner: 'bg-[#338AF3]',
    },
  },
  pink: {
    block: 'bg-[#FDECFC] !border !border-[#F333E0]',
    text: 'text-[#F333E0]',
    progressBar: {
      outer: 'bg-[#FAD1F6]',
      inner: 'bg-[#F333E0]',
    },
  },
  orange: {
    block: 'bg-[#FFFAEB] !border !border-[#F79009]',
    text: 'text-[#F79009]',
    progressBar: {
      outer: 'bg-[#FEEBDD]',
      inner: 'bg-[#F79009]',
    },
  },
  green: {
    block: 'bg-[#ECFDF3] !border !border-[#12B76A]',
    text: 'text-[#12B76A]',
    progressBar: {
      outer: 'bg-[#D1FADF]',
      inner: 'bg-[#12B76A]',
    },
  },
  purple: {
    block: 'bg-[#F9ECFD] !border !border-[#B733DD]',
    text: 'text-[#B733DD]',
    progressBar: {
      outer: 'bg-[#F1D1FA]',
      inner: 'bg-[#B733DD]',
    },
  },
  brown: {
    block: 'bg-[#FDEEEC] !border !border-[#7A2418]',
    text: 'text-[#7A2418]',
    progressBar: {
      outer: 'bg-[#FBDEDA]',
      inner: 'bg-[#7A2418]',
    },
  },
}

export const statusColors = {
  online: '#1AC057',
  offline: '#989898',
}
